// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"357":"d58552aefedcc462","464":"c247d3f87d298698","7595":"c19804833a07346f"}[chunkId] + ".js";
};